class BeforeAfterSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.beforeImage = null;
    this.afterImage = null;
    this.sliderLine = null;
    this.sliderHandler = null;
    this.sectionLoadHandler = null;
  }

  connectedCallback() {
    this.init();
    this.bindSectionLoad();
  }

  disconnectedCallback() {
    this.unbindSectionLoad();
    this.unbindSlider();
  }

  init() {
    // Find slider elements
    this.slider = this.querySelector('.before-and-after__range');
    this.beforeImage = this.querySelector('.before-and-after__before');
    this.afterImage = this.querySelector('.before-and-after__after');
    this.sliderLine = this.querySelector('.before-and-after__slider-line');

    if (!this.slider || !this.beforeImage || !this.afterImage || !this.sliderLine) {
      console.warn('Before/After Slider: Required elements not found');
      return;
    }

    // Remove existing listener if it exists
    this.unbindSlider();

    // Create bound handler for proper cleanup
    this.sliderHandler = () => {
      this.moveSlider();
    };

    // Initialize slider
    this.slider.addEventListener('input', this.sliderHandler);

    // Initial positioning
    this.moveSlider();
  }

  bindSectionLoad() {
    // Remove existing listener if it exists
    this.unbindSectionLoad();

    // Create bound handler for proper cleanup
    this.sectionLoadHandler = (event) => {
      // Only reinitialize if this element is in the loaded section
      if (event.detail && event.detail.sectionId) {
        const section = document.getElementById(`shopify-section-${event.detail.sectionId}`);
        if (section && section.contains(this)) {
          this.init();
        }
      } else {
        // Fallback: reinitialize if section info not available
        this.init();
      }
    };

    // Handle theme editor events
    document.addEventListener('shopify:section:load', this.sectionLoadHandler);
  }

  unbindSectionLoad() {
    if (this.sectionLoadHandler) {
      document.removeEventListener('shopify:section:load', this.sectionLoadHandler);
      this.sectionLoadHandler = null;
    }
  }

  unbindSlider() {
    if (this.slider && this.sliderHandler) {
      this.slider.removeEventListener('input', this.sliderHandler);
      this.sliderHandler = null;
    }
  }

  moveSlider() {
    if (!this.slider || !this.beforeImage || !this.afterImage || !this.sliderLine) {
      return;
    }

    const value = this.slider.value;
    
    // Update clip paths for images
    this.beforeImage.style.clipPath = `inset(0 ${100 - value}% 0 0)`;
    this.afterImage.style.clipPath = `inset(0 0 0 ${value}%)`;

    // Update slider line position
    this.sliderLine.style.setProperty('--slider-position', `${value}%`);
  }
}

// Register the custom element
customElements.define('before-after-slider', BeforeAfterSlider);
